import $ from "jquery";

const backButton = $(".category-sidenav-back a");
const { referrer } = document;

// Check to see if we have a backbutton on the page
// this is for news, events, consultations
if (backButton.length) {
  // If we've come from the parent index page set this referrer to be the href
  // this ensures that any filters that have been previously applied are part of the link
  if (referrer !== "" && referrer.indexOf(backButton.first().attr("href"))) {
    backButton.first().attr("href", referrer);
  }
}
